/*
 * Pages
 */
 
require('./pages/front/home');
require('./pages/front/article');
require('./pages/front/checkout');
require('./pages/front/experts');
require('./pages/front/profile');
require('./pages/front/profile-membership');
require('./pages/front/profile-practice-info');
require('./pages/front/public-profile');
require('./pages/front/onboarding');
require('./pages/front/messages');
require('./pages/front/resources');
